import React from "react";
import SearchBar from "@/components/SearchBar.js";
import Card from "../components/Card";
import Footer from "@/layout/Footer";
import GenericBanner from "@/components/GenericBanner";
import CustomSlider from "@/components/CustomSlider";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

const Trend = () => {
	const socialmediaCards = [
		{
			id: 1,
			icon: "assets/trend/xl/facebook.svg",
			title: "Facebook",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "#0866FF",
		},
		{
			id: 2,
			icon: "assets/trend/xl/instagram.svg",
			title: "Instagram",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "#FA4768",
		},
		{
			id: 3,
			icon: "assets/trend/xl/google.svg",
			title: "Google",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "#E5E5E5",
		},
		{
			id: 4,
			icon: "assets/trend/xl/twitter.svg",
			title: "Twitter",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "#999999",
		},
		{
			id: 5,
			icon: "assets/trend/xl/pinterest.svg",
			title: "Pinterest",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "#E60019",
		},
	];
	const facebookTopSellers = [
		{
			id: 1,
			image: "assets/trend/xl/facebook/card1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "Amazon",
		},
		{
			id: 2,
			image: "assets/trend/xl/facebook/card2.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 3,
			image: "assets/trend/xl/facebook/card3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "Amazon",
		},
		{
			id: 4,
			image: "assets/trend/xl/facebook/card4.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 5,
			image: "assets/trend/xl/facebook/card5.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 6,
			image: "assets/trend/xl/facebook/card2.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "AliBaba",
		},
	];
	const instagramTopSellers = [
		{
			id: 1,
			image: "assets/trend/xl/instagram/card1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "Amazon",
		},
		{
			id: 2,
			image: "assets/trend/xl/instagram/card2.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 3,
			image: "assets/trend/xl/instagram/card3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "Amazon",
		},
		{
			id: 4,
			image: "assets/trend/xl/instagram/card4.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 5,
			image: "assets/trend/xl/instagram/card5.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 6,
			image: "assets/trend/xl/instagram/card2.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "AliBaba",
		},
	];
	const googleTopSellers = [
		{
			id: 1,
			image: "assets/trend/xl/google/card1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "Amazon",
		},
		{
			id: 2,
			image: "assets/trend/xl/google/card2.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 3,
			image: "assets/trend/xl/google/card3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "Amazon",
		},
		{
			id: 4,
			image: "assets/trend/xl/google/card4.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 5,
			image: "assets/trend/xl/google/card5.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 6,
			image: "assets/trend/xl/google/card2.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonTopSellers/cardIcon.svg",
			platformName: "AliBaba",
		},
	];
	const similarProducts = [
		{
			id: 1,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "Amazon",
		},
		{
			id: 2,
			image: "assets/trend/xl/similarProducts/card2.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 3,
			image: "assets/trend/xl/similarProducts/card3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "Amazon",
		},
		{
			id: 4,
			image: "assets/trend/xl/similarProducts/card4.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 5,
			image: "assets/trend/xl/similarProducts/card5.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 6,
			image: "assets/trend/xl/similarProducts/card6.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 7,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 8,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},

		{
			id: 9,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 10,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 11,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},

		{
			id: 12,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 13,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 14,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 15,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 16,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 17,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 18,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 19,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 20,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 21,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 22,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 23,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
		{
			id: 24,
			image: "assets/trend/xl/similarProducts/card1.svg",
			priceRange: "$229 - 239",
			priceRange: "$199 - 219",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/trend/xl/similarProducts/titleIcon.svg",
			platformName: "AliBaba",
		},
	];
	const colorClassMap = {
		trend: "bg-[#D2DCD1]",
	};

	return (
		<>
			<div className="flex flex-col gap-[30px]">
				<SearchBar />
				<GenericBanner
					iconSrc="assets/product/xl/bannerLogo.svg"
					title="Trends"
					subtitle="+10,000 products listed"
					description="Find trending products on Facebook Marketplace, Instagram and TikTok and scale your dropshipping business effortlessly."
					bgColor={colorClassMap["trend"]}
				/>

				<div className="flex flex-col w-full xl:w-[90%] mx-auto h-auto   gap-[21px] my-[20px] hidden lg:flex">
					{/* Title */}
					<div className="w-full text-left">
						<h1 className="font-[Montserrat] font-semibold text-[28px] leading-[32px] text-[#193D34]">
							Top Products by Social Media
						</h1>
					</div>

					{/* Subtitle */}
					<div className="w-full text-left mb-[40px]">
						<p className="font-[Montserrat] font-normal text-[14px] leading-[14px] text-[#262A29]">
							Find trending products on Facebook Marketplace, Instagram and
							TikTok <br />
							and scale your dropshipping business effortlessly.
						</p>
					</div>

					{/* Cards */}
					<div className="w-full  flex flex-col gap-[32px]">
						{/* Top Row: First 3 cards */}
						<div className="grid grid-cols-3 gap-[32px]">
							{socialmediaCards.slice(0, 3).map((card) => (
								<Card key={card.id} content={card} variant="socialmediaCards" />
							))}
						</div>
					</div>
					{/* Top Row: First 3 cards */}
					<div className="w-full flex flex-row items-center justify-center gap-[26px] mx-auto">
						{socialmediaCards.slice(3, 5).map((card) => (
							<Card key={card.id} content={card} variant="socialmediaCards2" />
						))}
					</div>
				</div>

				<div className="flex flex-col w-full xl:w-[90%] mx-auto h-auto    gap-[21px]   my-[20px] hidden lg:flex mt-[20px]">
					<div className="w-full xl:w-[90%] mx-auto h-[52px] flex items-center gap-2">
						<div className="w-[32px] h-[32px] flex items-center justify-center">
							<img
								src="assets/trend/xl/facebook/titleIcon.svg"
								alt="fbIcon"
								className="w-full h-full"
							/>
						</div>

						{/* Text */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] text-[#193D34]">
							Facebook Top Sellers
						</h1>
					</div>

					<div className="w-full xl:w-[90%] mx-auto">
						<CustomSlider
							type="trend"
							cards={facebookTopSellers}
							cardsToShow={5}
							CardComponent={Card}
						/>
					</div>
				</div>

				<div className="flex flex-col w-full xl:w-[90%] mx-auto h-auto    gap-[21px]   my-[20px] hidden lg:flex mt-[20px]">
					<div className="w-full xl:w-[90%] mx-auto h-[52px] flex items-center gap-2">
						<div className="w-[32px] h-[32px] flex items-center justify-center">
							<img
								src="assets/trend/xl/instagram/titleIcon.svg"
								alt="fbIcon"
								className="w-full h-full"
							/>
						</div>

						{/* Text  */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] text-[#193D34]">
							Instagram Top Sellers
						</h1>
					</div>

					<div className="w-full xl:w-[90%] mx-auto">
						<CustomSlider
							type="trend"
							cards={instagramTopSellers}
							cardsToShow={5}
							CardComponent={Card}
						/>
					</div>
				</div>

				<div className="flex flex-col w-full xl:w-[90%] mx-auto h-auto    gap-[21px]   my-[20px] hidden lg:flex mt-[20px]">
					<div className="w-full xl:w-[90%] mx-auto h-[52px] flex items-center gap-2">
						<div className="w-[32px] h-[32px] flex items-center justify-center">
							<img
								src="assets/trend/xl/google/titleIcon.svg"
								alt="fbIcon"
								className="w-full h-full"
							/>
						</div>

						{/* Text  */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] text-[#193D34]">
							Google Top Sellers
						</h1>
					</div>

					<div className="w-full xl:w-[90%] mx-auto">
						<CustomSlider
							type="trend"
							cards={googleTopSellers}
							cardsToShow={5}
							CardComponent={Card}
						/>
					</div>
				</div>
				<div className="flex flex-col w-full xl:w-[90%] mx-auto h-auto    gap-[21px]   my-[20px] hidden lg:flex mt-[20px]">
					<div className="w-full xl:w-[90%] mx-auto h-[52px] flex items-center gap-2">
						<div className="w-[32px] h-[32px] flex items-center justify-center">
							<img
								src="assets/trend/xl/google/titleIcon.svg"
								alt="fbIcon"
								className="w-full h-full"
							/>
						</div>

						{/* Text  */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] text-[#193D34]">
							Similar Products
						</h1>
					</div>

					<div className="w-full xl:w-[90%] mx-auto">
						<CustomSlider
							type="trendSimilarProducts"
							cards={similarProducts}
							cardsToShow={6}
							CardComponent={Card}
						/>
					</div>
				</div>
				<div className="flex flex-col w-full xl:w-[90%] mx-auto h-auto    gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					<div className="w-[1230px] h-[826px] left-[85px] flex flex-col gap-[16px] hidden lg:flex">
						{/* First Paragraph */}
						<p className="font-montserrat font-bold text-[20px] leading-[32px] tracking-normal text-black align-middle">
							Dropshipping Trends on Social Media Platforms: Facebook,
							Instagram, and TikTok
						</p>

						{/* Second Paragraph */}
						<p className="font-montserrat font-normal text-[12px] leading-[12px] tracking-normal text-black">
							With the ever-expanding eCommerce industry, drop shipping has
							become one of the most lucrative and popular business models among
							entrepreneurs. Social networking platforms like Facebook,
							Instagram, and Google have helped instigate its success.
							<br />
							<br />
							It has become more critical than ever to gain insights from these
							platforms and leverage data that will help you find trending
							dropshipping products and scale your business.
							<br />
							<br />
							Rbetraj's Dropshipping tool automates the whole process by helping
							you find winning products on Facebook Marketplace, Instagram, and
							TikTok.
							<br />
							<br />
							It simplifies your sourcing strategy by doing the hard work of
							recognizing profitable products derived from data-driven insights.
						</p>

						{/* Third Paragraph */}
						<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal text-black align-middle">
							Facebook Marketplace Dropshipping Tool
						</p>

						{/* Fourth Paragraph */}
						<p className="font-montserrat font-normal text-[12px] leading-[12px] tracking-normal text-black">
							Facebook Marketplace is one of the most leveraged platforms by
							business owners because it has a huge audience base to sell to.
							However, managing your Facebook marketplace and identifying
							winning products can be time-consuming. That's where our Automated
							Facebook marketplace dropshipping Software comes in.
							<br />
							<br />
							With our tool, you can find winning dropshipping products on
							Facebook Marketplace, save energy, save time, and increase
							productivity. You can also easily automate your product listing,
							inventory updating, and order fulfillment.
							<br />
							<br />
							Our tool analyzes current trends and sales data to give you
							insights into which products are in demand, which ones have the
							best reviews, and which ones can maximize your profits. Our
							Facebook Marketplace Dropshipping Automation Software automates
							the entire process to help you stay ahead of the competition and
							increase your revenue.
						</p>

						{/* Fifth Paragraph */}
						<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal text-black align-middle">
							Instagram Dropshipping Automation Tool: Find Trending Dropshipping
							Products on Instagram in Minutes
						</p>

						{/* Sixth Paragraph */}
						<p className="font-montserrat font-normal text-[12px] leading-[12px] tracking-normal text-black">
							Instagram is another great platform for selling products because
							it is very visual. You can create eye-catching product posts and
							showcase them to millions of people. However, running an Instagram
							store without the right strategy can be very stressful. Our &nbsp;
							<strong>Automated Instagram Dropshipping Software</strong> takes
							away the stress of running your Instagram store by easily
							importing products from your suppliers and automating posting,
							product management, and customer management.
							<br />
							<br />
							Since Rbetraj's Instagram automation software is AI-driven, it
							quickly sources the best products trending on Instagram and gives
							insights on market trends so that you can stock your store with
							demanded products.
							<br />
							<br />
						</p>

						{/* Seventh Paragraph */}
						<p className="font-montserrat  text-[13px] leading-[24px] tracking-normal align-middle">
							<span className="font-semibold">
								TikTok Shop Dropshipping Automation
							</span>
							Easier Than Ever Before
						</p>

						{/* Eighth Paragraph */}
						<p className="font-montserrat font-normal text-[12px] leading-[12px] tracking-normal text-black">
							TikTok is one of the most vibrant platforms for discovering
							trending products. It offers unparalleled potential to expose a
							huge audience to its viral videos and engaging content. However,
							to compete with others, TikTok dropshipping requires a unique
							strategy and the right tools. Our Automated TikTok Dropshipping is
							designed to automate your store management and product listing
							optimization on the platform.
							<br />
							<br />
							With TikTok Shop, dropshipping is even easier. In-app e-commerce
							integration on TikTok allows you to sell directly on the app, and
							our TikTok Shop Dropshipping Automation tool automates the order
							and inventory management process. Automate the tedious parts of
							your business so you can focus on creating engaging TikTok videos
							for your products.
							<br />
							<br />
							Find trending dropshipping products on TikTok with our tool, which
							tracks viral trends and identifies products with the most
							momentum. This keeps you ahead and allows you to profit from these
							products before your competitors. With TikTok's robust algorithm,
							it has never been simpler to uncover winning dropshipping products
							on TikTok.
						</p>

						{/* Ninth Paragraph */}
						<p className="font-montserrat  text-[13px] leading-[24px] tracking-normal align-middle">
							<span className="font-semibold">
								Automate TikTok Dropshipping
							</span>
							&nbsp; with Rbetraj's intuitive tool!
						</p>

						{/* Tenth Paragraph */}
						<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal align-middle">
							Why Automation Is Necessary for Dropshipping Success?
						</p>

						{/* Eleventh Paragraph */}
						<p className="font-montserrat font-normal text-[12px] leading-[12px] tracking-normal">
							The key to success in dropshipping is efficiency, and the secret
							to efficiency is automation. By using our Top Automation Software
							For Instagram Dropshipping, Facebook, Marketplace, and TikTok, you
							can rest assured that your business will run smoothly and
							consistently. Automation takes the grunt work out of managing
							dropshipping stores, allowing you the time to scale your business
							and tweak your marketing.
							<br />
							<br />
							Our Software is built with the entrepreneur in mind, and we offer
							easy-to-use interfaces and powerful features that make managing
							your products and sales a breeze. Whether you wish to expand your
							business on Facebook Marketplace, Instagram, or TikTok, our top
							automation software for dropshipping enables you to stay
							organized, discover trending products, and ultimately increase
							profitability.
						</p>
					</div>
				</div>
			</div>
			{/*Mobile view*/}
			<div className="lg:hidden w-full h-[268px] pt-4 pr-5 pb-4 pl-5 gap-4 bg-[#193D34]">
				{/* Navigation Tabs */}
				<div className="w-[378px] h-[36px] pr-5 pb-2 pl-1 gap-1 flex items-center mt-4">
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Products
						</span>
					</div>
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Shops
						</span>
					</div>
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Trends
						</span>
					</div>
				</div>

				<div className="w-[338px] h-[40px] rounded-lg border-[1.6px] border-gray-300 overflow-hidden mt-3">
					<div className="relative flex items-center w-full h-full">
						<input
							type="text"
							placeholder="Search product.."
							className="pl-4 pr-12 w-full h-full bg-white text-black placeholder:text-gray-400 outline-none focus:ring-0"
						/>
						<button className="absolute right-0 flex items-center justify-center w-[40px] h-full bg-[#B7D974] hover:bg-[#A9C864] transition-colors">
							<img
								src="/assets/home/topnav/search.png"
								alt="Search"
								className="w-[20px] h-[20px]"
							/>
						</button>
					</div>
				</div>

				<div className="lg:hidden w-[338px] flex flex-wrap items-center mt-6 gap-4">
					{/* Filter By Label */}
					<span className="font-montserrat font-normal text-[16px] leading-[32px] text-[#F6F6F6] whitespace-nowrap">
						Filter By :
					</span>

					{/* Buttons */}
					{[
						"Top Sellers",
						"Only Amazon",
						"Only Alibaba",
						"Top in Marketplace",
					].map((label, index) => (
						<button
							key={index}
							className="object-contain  h-[30px] px-[12px] py-[8px] flex items-center justify-center gap-[10px] rounded-[20px] border border-[#A7C56A] bg-[#47645D]"
						>
							<span className="whitespace-nowrap  font-montserrat font-medium text-[13px] leading-[100%] tracking-[0%] text-center text-white">
								{label}
							</span>
						</button>
					))}
				</div>
			</div>

			<div className="w-full lg:hidden flex flex-col items-center">
				{/* Icon container with background */}
				<div className="w-full h-[130px] flex items-center justify-center bg-[#D2DCD1]">
					<div className="w-[378px] h-full flex items-center justify-center">
						<img
							src="assets/product/mobile/rbetrajLogo.svg"
							alt="Icon"
							className="max-w-full max-h-full object-center object-contain"
						/>
					</div>
				</div>

				{/* Text content container */}
				<div className="w-full flex items-center justify-center bg-[#E8ECEB] py-4">
					<div className="w-[378px] flex flex-col items-start text-left space-y-1">
						<p className="font-montserrat font-bold text-[20px] leading-[32px] tracking-normal text-[#193D34]">
							Trends
						</p>
						<p className="font-montserrat font-normal text-[12px] leading-[12px] text-[#7A7A7A]">
							+10,000 products listed
						</p>
						<p className="font-montserrat font-semibold text-[12px] leading-[12px] text-[#7A7A7A]">
							Find trending products for dropshipping among trusted and reliable
							suppliers across the globe.
						</p>
					</div>
				</div>
			</div>
			<div className="w-full lg:hidden flex items-center justify-between px-2 my-8">
				{/* Breadcrumbs */}
				<div className="flex items-center space-x-2 overflow-x-auto">
					<div className="flex items-center space-x-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
							Trends
						</span>
						<img
							src="assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
					<div className="flex items-center space-x-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
							Facebook
						</span>
						<img
							src="assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
					<div className="flex items-center space-x-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
							Tagsword
						</span>
						<img
							src="assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
				</div>

				{/* Sort By Button */}
				<button className="w-[122px] h-[32px] flex items-center justify-between border border-[#193D34] rounded-[24px] px-2 gap-2">
					<img
						src="assets/product/mobile/sortIconStart.svg"
						alt="start icon"
						className="w-[16px] h-[16px]"
					/>
					<span className="font-montserrat font-medium text-[13px] leading-[24px] text-[#193D34] text-center">
						Sort by
					</span>
					<img
						src="assets/product/mobile/sortIconEnd.svg"
						alt="end icon"
						className="w-[16px] h-[16px]"
					/>
				</button>
			</div>
			<div className="grid grid-cols-1 gap-[40px]  w-full block lg:hidden my-20">
				{socialmediaCards.map((card) => (
					<Card key={card.id} content={card} variant="socialmediaCards" />
				))}
			</div>
			<div className="w-full h-[390px]  flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-left mb-4 flex items-center gap-2">
						<img
							src="assets/trend/xl/facebook/titleIcon.svg"
							alt="fbIcon"
							className="w-[24px] h-[24px]"
						/>
						Facebook Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="assets/trend/mobile/sliderNavButton.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="assets/trend/mobile/sliderNavButton.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{facebookTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px]  flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-left mb-4 flex items-center gap-2">
						<img
							src="assets/trend/xl/instagram/titleIcon.svg"
							alt="fbIcon"
							className="w-[24px] h-[24px]"
						/>
						Instagram Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="assets/trend/mobile/sliderNavButton.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="assets/trend/mobile/sliderNavButton.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{instagramTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px]  flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-left mb-4 flex items-center gap-2">
						<img
							src="assets/trend/xl/google/titleIcon.svg"
							alt="fbIcon"
							className="w-[24px] h-[24px]"
						/>
						Google Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="assets/trend/mobile/sliderNavButton.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="assets/trend/mobile/sliderNavButton.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{googleTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="flex flex-col w-full h-auto px-4 gap-4 block lg:hidden my-4">
				<div className="flex flex-col gap-4">
					{/* First Paragraph */}
					<p className="font-montserrat font-bold text-[18px] leading-[26px] text-black">
						Dropshipping Trends on Social Media Platforms: Facebook, Instagram,
						and TikTok
					</p>

					{/* Second Paragraph */}
					<p className="font-montserrat text-[14px] leading-[20px] text-black">
						With the ever-expanding eCommerce industry, drop shipping has become
						one of the most lucrative and popular business models...
						<br />
						<br />
						Rbetraj's Dropshipping tool automates the whole process by helping
						you find winning products...
					</p>

					{/* Facebook Section */}
					<p className="font-montserrat font-semibold text-[15px] leading-[22px] text-black">
						Facebook Marketplace Dropshipping Tool
					</p>
					<p className="font-montserrat text-[14px] leading-[20px] text-black">
						Facebook Marketplace is one of the most leveraged platforms by
						business owners...
						<br />
						<br />
						Our tool analyzes current trends and sales data to give you insights
						into which products are in demand...
					</p>

					{/* Instagram Section */}
					<p className="font-montserrat font-semibold text-[15px] leading-[22px] text-black">
						Instagram Dropshipping Automation Tool: Find Trending Dropshipping
						Products on Instagram in Minutes
					</p>
					<p className="font-montserrat text-[14px] leading-[20px] text-black">
						Instagram is another great platform for selling products because it
						is very visual...
						<br />
						<br />
						Since Rbetraj's Instagram automation software is AI-driven, it
						quickly sources the best products...
					</p>

					{/* TikTok Section */}
					<p className="font-montserrat font-semibold text-[15px] leading-[22px] text-black">
						TikTok Shop Dropshipping Automation Easier Than Ever Before
					</p>
					<p className="font-montserrat text-[14px] leading-[20px] text-black">
						TikTok is one of the most vibrant platforms for discovering trending
						products...
						<br />
						<br />
						Find trending dropshipping products on TikTok with our tool...
					</p>

					<p className="font-montserrat font-semibold text-[15px] leading-[22px] text-black">
						Automate TikTok Dropshipping with Rbetraj's intuitive tool!
					</p>

					{/* Automation Importance */}
					<p className="font-montserrat font-semibold text-[15px] leading-[22px] text-black">
						Why Automation Is Necessary for Dropshipping Success?
					</p>
					<p className="font-montserrat text-[14px] leading-[20px] text-black">
						The key to success in dropshipping is efficiency, and the secret to
						efficiency is automation...
						<br />
						<br />
						Our Software is built with the entrepreneur in mind, and we offer
						easy-to-use interfaces...
					</p>
				</div>
			</div>

			<Footer />
		</>
	);
};

export default Trend;
